export default __webpack_public_path__ + "static/media/turnin.83e5ef50.svg";